import { createSlice } from '@reduxjs/toolkit';
import { fetchNotificationSummary } from '@/apis/notifications';
import { fetchChatUnread } from '@/apis/chat';

const initialState = { unread_count: 0, chat_unread_count: 0, alert_unread_count: null, chat_alert_unread_count: null, has_unread: false, latest_id: 0, requestId: null, chatRequestId: null };
const notifications = createSlice({
  name: 'notifications', initialState,
  reducers: {
    startSummary(state, action) { state.requestId = action.payload; },
    startChatSummary(state, action) { state.chatRequestId = action.payload; },
    setChatSummary(state, action) {
      if (state.chatRequestId !== action.payload.requestId) return;
      state.chat_unread_count = action.payload.count; state.chat_alert_unread_count = action.payload.alertCount; state.chatRequestId = null;
    },
    setSummary(state, action) {
      if (action.payload.requestId !== undefined && action.payload.requestId !== state.requestId) return;
      Object.assign(state, action.payload.summary, { requestId: null });
    },
    resetNotifications: () => initialState,
  },
  extraReducers: builder => builder
    .addCase('user/clearUserState', () => initialState)
    .addCase('user/setAuthenticated', () => initialState),
});
export const { setSummary, resetNotifications } = notifications.actions;
export const selectUnreadCount = state => state.user.isAuthenticated ? state.notifications?.unread_count || 0 : 0;
export const selectChatUnreadCount = state => state.user.isAuthenticated ? state.notifications?.chat_unread_count || 0 : 0;
export const selectAlertUnreadCount = state => state.user.isAuthenticated ? state.notifications?.alert_unread_count ?? state.notifications?.unread_count ?? 0 : 0;
export const selectChatAlertUnreadCount = state => state.user.isAuthenticated ? state.notifications?.chat_alert_unread_count ?? state.notifications?.chat_unread_count ?? 0 : 0;
export const validSummary = data => Number.isInteger(data?.unread_count) && data.unread_count >= 0
  && Number.isInteger(data?.latest_id) && data.latest_id >= 0 && typeof data?.has_unread === 'boolean'
  && (data.alert_unread_count === undefined || (Number.isInteger(data.alert_unread_count) && data.alert_unread_count >= 0))
  && (data.has_alert_unread === undefined || typeof data.has_alert_unread === 'boolean');
export const sessionKey = state => `${state.user.sessionVersion}:${state.user.userInfo?.id}`;
let sequence = 0;
export const refreshChatSummary = () => async (dispatch, getState) => {
  if (!getState().user.isAuthenticated || !getState().user.userInfo?.id) return;
  const key = sessionKey(getState()); const requestId = ++sequence;
  dispatch(notifications.actions.startChatSummary(requestId));
  const result = await fetchChatUnread();
  if (!Number.isInteger(result?.unread_count) || result.unread_count < 0) throw new Error('聊天统计响应无效');
  if (result.alert_unread_count !== undefined && (!Number.isInteger(result.alert_unread_count) || result.alert_unread_count < 0)) throw new Error('聊天统计响应无效');
  if (getState().user.isAuthenticated && sessionKey(getState()) === key) dispatch(notifications.actions.setChatSummary({ count: result.unread_count, alertCount: result.alert_unread_count ?? result.unread_count, requestId }));
  return result;
};
export const refreshNotificationSummary = () => async (dispatch, getState) => {
  if (!getState().user.isAuthenticated || !getState().user.userInfo?.id) return;
  const key = sessionKey(getState());
  const requestId = ++sequence;
  dispatch(notifications.actions.startSummary(requestId));
  const result = await fetchNotificationSummary();
  if (!validSummary(result)) throw new Error('通知统计响应无效');
  if (getState().user.isAuthenticated && sessionKey(getState()) === key) dispatch(setSummary({ summary: result, requestId }));
  return result;
};
export default notifications.reducer;
